module.exports = __webpack_public_path__ + "img/mingsheng_icon.67ec06ad.png";